var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAvatarDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5001 11.375C34.5407 11.375 11.8751 34.0406 11.8751 62C11.8751 89.9594 34.5407 112.625 62.5001 112.625C90.4595 112.625 113.125 89.9594 113.125 62C113.125 34.0406 90.4595 11.375 62.5001 11.375ZM0.625122 62C0.625122 27.8274 28.3275 0.125 62.5001 0.125C96.6728 0.125 124.375 27.8274 124.375 62C124.375 96.1726 96.6727 123.875 62.5001 123.875C28.3275 123.875 0.625122 96.1726 0.625122 62Z",
    fill: "#3D0E6B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_4690)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5001 32C55.8251 32 50.5001 37.325 50.5001 43.775C50.5001 50.225 55.8251 55.55 62.5001 55.55C69.1751 55.55 74.5001 50.225 74.5001 43.775C74.5001 37.325 69.1751 32 62.5001 32ZM43.0001 43.775C43.0001 33.05 51.7751 24.5 62.5001 24.5C73.2251 24.5 82.0001 33.05 82.0001 43.775C82.0001 54.5 73.2251 63.05 62.5001 63.05C51.7751 63.05 43.0001 54.4625 43.0001 43.775Z",
    fill: "#3D0E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4251 63.875V72.3875C86.6501 73.2125 89.0501 76.1375 89.0501 79.625V83.4875C89.0501 84.5375 88.2251 85.3625 87.1751 85.3625C86.1251 85.3625 85.3001 84.5375 85.3001 83.4875V79.625C85.3001 77.5625 83.6126 75.875 81.5501 75.875C79.4876 75.875 77.8001 77.5625 77.8001 79.625V83.4875C77.8001 84.5375 76.9751 85.3625 75.9251 85.3625C74.8751 85.3625 74.0501 84.5375 74.0501 83.4875V79.625C74.0501 76.1375 76.4501 73.2125 79.6751 72.3875V63.9125C78.0626 64.1375 76.4501 64.5125 74.9876 65.225L68.9876 68.225C64.9001 70.25 60.1751 70.25 56.0876 68.2625L49.8251 65.225C48.4001 64.55 46.9001 64.175 45.3251 63.9875V72.425C48.5501 73.25 50.9501 76.175 50.9501 79.6625C50.9501 83.7875 47.5751 87.1625 43.4501 87.1625C39.3251 87.1625 35.9501 83.7875 35.9501 79.6625C35.9501 76.175 38.3501 73.25 41.5751 72.425V63.95C34.3376 64.85 28.7501 70.925 28.7501 78.425C28.7501 85.475 33.4376 91.7375 40.3376 93.2375C56.6126 96.725 68.8751 96.575 84.7001 93.2375C91.6001 91.775 96.2876 85.5125 96.2876 78.4625C96.2876 70.925 90.6626 64.85 83.4626 63.95L83.4251 63.875Z",
    fill: "#FFB6BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4501 83.375C45.5211 83.375 47.2001 81.6961 47.2001 79.625C47.2001 77.5539 45.5211 75.875 43.4501 75.875C41.379 75.875 39.7001 77.5539 39.7001 79.625C39.7001 81.6961 41.379 83.375 43.4501 83.375Z",
    fill: "#FFB6BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_4690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.5,
    height: 71.25,
    fill: "white",
    transform: "translate(28.7501 24.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvatarDoctor);
export default __webpack_public_path__ + "static/media/ic_avatar_doctor.f93111dfc0eff1e3c759046a70ce8af0.svg";
export { ForwardRef as ReactComponent };